var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.635,
    height: 12.996,
    viewBox: "0 0 7.635 12.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-101.478)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.906,5.991,103.122.208a.712.712,0,0,0-1.005,0l-.426.426a.712.712,0,0,0,0,1.005L106.547,6.5l-4.862,4.862a.713.713,0,0,0,0,1.006l.426.426a.712.712,0,0,0,1.005,0L108.906,7a.717.717,0,0,0,0-1.009Z",
    transform: "translate(-101.478 0)",
    fill: "#697384"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.6cdd3c1dc2e6be77ec8b38668f77bf03.svg";
export { ForwardRef as ReactComponent };